import { render } from "./HomeFramesCarousel.vue?vue&type=template&id=4c74bff3&scoped=true&ts=true"
import script from "./HomeFramesCarousel.vue?vue&type=script&lang=ts"
export * from "./HomeFramesCarousel.vue?vue&type=script&lang=ts"

import "./HomeFramesCarousel.vue?vue&type=style&index=0&id=4c74bff3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c74bff3"]])

export default __exports__